import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IQueryProps } from '@/entities/Query'

/**
 * ルーム内の予約送信一覧
 *
 * 指定されたチャットルームの、ログイン中の医師自身が予約した未送信メッセージの一覧を返す
 */
export class FetchScheduledTalk implements APIRequest<Monitaro.FetchScheduledTalkResponse> {
  response: Monitaro.FetchScheduledTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: IQueryProps
  constructor(room: string, query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms/${room}/scheduled-talks`
  }
}

/**
 * 全ルーム横断の予約送信一覧
 *
 * ログイン中の医師自身が予約した、ルームを問わない全件の未送信メッセージの一覧を返す
 */
export class FetchAllScheduledTalk implements APIRequest<Monitaro.FetchAllScheduledTalkResponse> {
  response: Monitaro.FetchAllScheduledTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: IQueryProps
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/scheduled-talks`
  }
}

/**
 * トークの予約送信を作成
 *
 * 指定されたチャットルームへの発言を予約する。予約時刻が到来するまで相手には一切表示されない
 */
export class PostScheduledTalk implements APIRequest<Monitaro.PostScheduledTalkResponse> {
  response: Monitaro.PostScheduledTalkResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.ScheduledTalkRequest
  constructor(room: string, params: Monitaro.ScheduledTalkRequest) {
    this.params = params
    this.path = `/rooms/${room}/scheduled-talks`
  }
}

/**
 * トークの予約送信を編集
 *
 * 未送信の予約の本文・添付ファイル・予約日時を編集する
 */
export class PutScheduledTalk implements APIRequest<Monitaro.PutScheduledTalkResponse> {
  response: Monitaro.PutScheduledTalkResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.PUT
  params: Monitaro.ScheduledTalkRequest
  constructor(room: string, scheduledTalk: string, params: Monitaro.ScheduledTalkRequest) {
    this.params = params
    this.path = `/rooms/${room}/scheduled-talks/${scheduledTalk}`
  }
}

/**
 * トークの予約送信をキャンセル
 *
 * 未送信の予約をキャンセルする。送信済みの予約は対象外
 */
export class DeleteScheduledTalk implements APIRequest<Monitaro.DeleteScheduledTalkResponse> {
  response: Monitaro.DeleteScheduledTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(room: string, scheduledTalk: string) {
    this.path = `/rooms/${room}/scheduled-talks/${scheduledTalk}`
  }
}

/**
 * トークの予約送信を今すぐ送信
 *
 * 予約時刻を待たず、その場で送信を実行する。無効な予約になっている場合は送信せずキャンセル扱いにする
 */
export class PutSendScheduledTalk implements APIRequest<Monitaro.PutSendScheduledTalkResponse> {
  response: Monitaro.PutSendScheduledTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  constructor(room: string, scheduledTalk: string) {
    this.path = `/rooms/${room}/scheduled-talks/${scheduledTalk}/send`
  }
}
